import { CustomOrderType } from '@spa/lib/store/carts/CustomOrderType';

// UPDATE isEqual if any field is added/modified
export interface Session {
  readonly favoriteStoreId: string | null;
  readonly guid: string;
  readonly isPersisted: boolean;
  readonly latestSelectedDeliveryMethod: CustomOrderType | null;
  readonly selectedWishlist: string | null;
  readonly tokens: SessionTokens | null;
  readonly showOverheadComponent: boolean;
}

export interface SessionTokens {
  readonly accessToken: string;
  readonly expiresAtTsSeconds: number;
  readonly expiresInSeconds: number;
  readonly refreshToken: string | null;
}

export const isEqual = (a: Session | null, b: Session | null): boolean => {
  let isSessionEqual: boolean;
  if (a === b) {
    isSessionEqual = true;
  } else if (a === null || b === null) {
    isSessionEqual = false;
  } else {
    isSessionEqual =
      a.favoriteStoreId === b.favoriteStoreId &&
      a.guid === b.guid &&
      a.isPersisted === b.isPersisted &&
      a.latestSelectedDeliveryMethod === b.latestSelectedDeliveryMethod &&
      a.selectedWishlist === b.selectedWishlist &&
      a.showOverheadComponent === b.showOverheadComponent &&
      areTokensEqual(a.tokens, b.tokens);
  }

  return isSessionEqual;
};

const areTokensEqual = (a: SessionTokens | null, b: SessionTokens | null): boolean => {
  let areTokensEqualResult: boolean;
  if (a === b) {
    areTokensEqualResult = true;
  } else if (a === null || b === null) {
    areTokensEqualResult = false;
  } else {
    areTokensEqualResult =
      a.accessToken === b.accessToken &&
      a.expiresAtTsSeconds === b.expiresAtTsSeconds &&
      a.expiresInSeconds === b.expiresInSeconds &&
      a.refreshToken === b.refreshToken;
  }

  return areTokensEqualResult;
};
